import { Button } from 'antd';
import React, { ReactElement, useState } from 'react';
import { EventCalenderProps } from '../../../../shared/models/hospitalProfile.model';
import AddCalendarForm from '../../shared/AddCalendarForm';

const AddCalendar = ({ onSaveCalendar }: EventCalenderProps): ReactElement => {
  const [isAddCalendar, setIsAddCalendar] = useState(false);

  const onAddCalendar = (): void => {
    setIsAddCalendar(true);
  };

  const onOk = (): void => {
    setIsAddCalendar(false);
    onSaveCalendar(false);
  };

  const onCancel = (): void => {
    setIsAddCalendar(false);
  };

  return (
    <div style={{ height: 'max-content' }} className="text-right">
      <Button onClick={onAddCalendar}>+ Create Event</Button>
      {isAddCalendar && (
        <AddCalendarForm visible={isAddCalendar} onCancel={onCancel} onOk={onOk} title={'Event Details'}
          defaultDate={{ start: new Date(), end: new Date() }} />
      )}
    </div>
  );
};

export default AddCalendar;
